module.exports = __webpack_public_path__ + "assets/img/carousel-3-1280.5441885b.webp";